import type { BoxProps } from '@hover/blueprint';
import { Box, Heading, Spacer } from '@hover/blueprint';
import { Flex, Grid, GridItem } from '@hover/blueprint/chakra';
import React from 'react';

import { useIsLandscape } from 'src/shared/hooks';

interface ListProps extends BoxProps {
  children: React.ReactNode[];
  subHeader?: React.ReactNode;
  expandHeader?: React.ReactNode;
  expandButton?: React.ReactNode;
  header: string | React.ReactNode;
  wrapItems?: boolean;
}

const List = ({
  header,
  children,
  marginBottom = 0,
  subHeader,
  expandHeader,
  expandButton,
  wrapItems,
  ...props
}: ListProps) => {
  const [isLandscape] = useIsLandscape();
  const shouldWrap = wrapItems === undefined ? isLandscape : wrapItems;

  return (
    <Box display="block" marginBottom={marginBottom} {...props}>
      <Flex>
        <Heading marginBottom={300} marginTop={100} size={200} width={1}>
          {header}
        </Heading>
        {expandHeader ? <Spacer /> : null}
        {expandHeader}
      </Flex>
      {subHeader}
      <Grid position="relative" templateColumns="1fr" templateRows="1fr">
        <GridItem
          colSpan={expandButton ? 1 : 2}
          colStart={1}
          overflow="auto"
          paddingRight={400}
          paddingTop={100}
          rowSpan={1}
          rowStart={1}
        >
          <Flex>
            <Box
              flexWrap={shouldWrap ? 'wrap' : 'nowrap'}
              paddingBottom={200}
              paddingRight={expandButton ? 600 : 400}
            >
              {children}
            </Box>
          </Flex>
        </GridItem>

        {expandButton ? (
          <GridItem
            background="linear-gradient(to right, rgba(255,255,255,0), rgba(255,255,255,1) 40%)"
            display="flex"
            justifyContent="flex-end"
            marginTop={100}
            position="absolute"
            right={0}
            width={70}
          >
            <Box display="inline-block">{expandButton}</Box>
          </GridItem>
        ) : null}
      </Grid>
    </Box>
  );
};

export { List };
